<template>
  <div class="entrance">
    <div class="privacy" v-loading="loading">
      <div class="welcome">
        <img src="@/assets/images/avatar-genio60.svg" alt="" />
        <h1>{{ $t("GPT.LAYOUT.WELCOME") }}</h1>
      </div>
      <div class="privacy-title">{{ $t("GPT.ENTRANCE.POLICY") }}</div>

      <div
        class="privacy-content ql-editor"
        v-if="setting"
        v-html="setting.ChatGPT_PrivacyNotice"
      ></div>

      <p>{{ $t("GPT.ENTRANCE.AGREE") }}</p>
      <label
        :aria-label="
          agree ? 'checked Agree checkbox' : 'not checked Agree checkbox'
        "
      >
        <input
          type="checkbox"
          v-model="agree"
          :aria-label="
            agree ? 'checked Agree checkbox' : 'not checked Agree checkbox'
          "
        />
        {{ $t("GPT.LAYOUT.AGREE") }}
      </label>
    </div>
    <el-button
      type="primary"
      :disabled="!agree || loading"
      @click="beforeCreateBotRoom"
      @keyup.enter="beforeCreateBotRoom"
      >{{ $t("GPT.LAYOUT.START") }}</el-button
    >
    <div class="history" v-if="pastHours !== null">
      <i class="bx bx-history"></i>
      {{
        $t("GPT.HISTORY.AGO", {
          hours: pastHours,
        })
      }}
    </div>
  </div>
</template>

<script>
import { languages } from "@/plugins/languages";
import { Customer } from "@/api/customer";
export default {
  name: "gpt-entrance",
  data() {
    return {
      agree: false,
    };
  },
  watch: {
    agree(val) {
      if (val) {
        window.dataLayer.push({
          event: "data_layer_event",
          chatbot_session_id: "",
          event_name_ga4: "agree_genio",
          event_category_DL: "genio",
          event_action_DL: "clicked",
          event_label_DL: "agree/genio",
        });
      }
    },
  },
  async mounted() {
    // 入口可能需要再觸發一次
    // this.$store.dispatch("global/checkLastRoomInfo");
  },
  methods: {
    async beforeCreateBotRoom() {
      const { isSingleServiceTime, isServiceTime } = this.beforeChat;
      // 是營業時間 = 直接看紀錄
      // 非營業時間 = 建立Room -> 看紀錄
      if (this.lastClientChatRoomInfo?.id) {
        this.$router.push(`/chat_history/${this.lastClientChatRoomInfo.id}`);
        // if (
        //   (isSingleServiceTime && isServiceTime) ||
        //   (!isSingleServiceTime && (await this.isRoomSkillServie()))
        // ) {
        //   // 是單一服務時間的話，看 isServiceTime
        //   // 非單一服務時間的話，看skill是否服務

        //   this.$router.push(`/chat_history/${this.lastClientChatRoomInfo.id}`);
        // } else {
        //   this.createBotRoom();
        // }
      } else if (this.lastChatBotRoomInfo?.chatBotRoomId) {
        // BOT 不用管是否營業，可以直接開房，進入後再顯是可以觀看紀錄的按鈕
        // this.createBotRoom();
        this.$router.push(
          `/bot_history/${this.lastChatBotRoomInfo.chatBotRoomId}`
        );
      } else {
        this.createBotRoom();
      }
    },
    createBotRoom() {
      this.$store.dispatch("gpt/createRoom");
    },
    async isRoomSkillServie() {
      const skill = this.lastClientChatRoomInfo.users.find(
        (user) => user.isCustomer
      ).product;

      const countryId = this.config.countryId.toUpperCase();
      try {
        const res = await Customer.GetCountryAllSkill({ countryId });
        const ta = res.data.find((el) => el.skillName_Global === skill);
        if (ta) {
          // console.log(skill, ta.isSkillService ? "有營業" : "無營業");
          return ta.isSkillService;
        } else {
          console.log("No skill.");
          return false;
        }
      } catch (error) {
        console.log("catch", error);
      }
    },
  },
  computed: {
    setting() {
      return this.$store.state.gpt.setting;
    },
    loading() {
      return this.$store.state.gpt.loading;
    },
    config() {
      return this.$store.state.global.config;
    },
    beforeChat() {
      return this.$store.state.gpt.beforeChat;
    },
    pastHours() {
      const lastRoomInfo = this.$store.state.global.lastRoomInfo;
      const { lastClientChatRoomInfo, lastChatBotRoomInfo } = lastRoomInfo;
      if (lastClientChatRoomInfo) {
        if (lastClientChatRoomInfo.pastHours <= 1) {
          return 1; // 0~1小時都回傳 1
        } else {
          return lastClientChatRoomInfo.pastHours;
        }
      } else if (lastChatBotRoomInfo) {
        if (lastChatBotRoomInfo.pastHours <= 1) {
          return 1; // 0~1小時都回傳 1
        } else {
          return lastChatBotRoomInfo.pastHours;
        }
      } else {
        return null;
      }
    },
    lastClientChatRoomInfo() {
      return this.$store.state.global.lastClientChatRoomInfo;
    },
    lastChatBotRoomInfo() {
      return this.$store.state.global.lastChatBotRoomInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.entrance {
  width: 100%;
  padding: 38px 20px;
  height: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  .privacy {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .welcome {
      text-align: center;
      margin-bottom: 20px;
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-bottom: 10px;
      }
      h1 {
        margin: 0;
        font-family: Noto Sans TC;
        font-weight: 700;
        color: $primary;
        font-size: 18px;
        line-height: 32.76px;
      }
    }
    .privacy-title {
      color: #181818;
      font-size: 14px;
      line-height: 16.8px;
      margin-bottom: 8px;
      text-align: center;
    }
    .privacy-content {
      @include scrollbar();
      width: 100%;
      color: #4d4d4d;
      height: 80px;
      min-height: 80px;
      overflow-y: auto;
      overflow-x: hidden;
      font-size: 13px;
      line-height: 20px;
      margin-bottom: 5px;
    }
    p {
      width: 100%;
      display: block;
      border-top: 1px solid #ccc;
      color: #666;
      font-size: 13px;
      line-height: 20px;
      text-align: center;
      padding-top: 8px;
      margin-bottom: 8px;
    }
  }
  .el-button {
    margin-top: 40px;
    width: 320px;
    max-width: 100%;
  }
  .history {
    display: flex;
    align-items: center;
    margin-top: 10px;
    i {
      margin-right: 10px;
    }
  }
}
</style>
